/**
 * 保存图片工具函数
 * 兼容 H5 环境，App 环境仅做判断
 */
import { isInApp, isInVest, saveImage, saveImageVest } from "@/libs/comeAppSDK";
import { blobToBase64, previewFileToBlob } from "./file";

/**
 * 保存base64图片到相册/下载
 * @param base64 图片base64
 * @param filename 文件名（可选）
 * @returns Promise<boolean> 是否保存成功
 */
export const saveBase64Image = async (base64: string, filename: string = 'image.png'): Promise<boolean> => {
  if (!base64) return Promise.resolve(false);
  if (isInApp()) {
    if (isInVest()) {
      return saveImageVest(base64);
    } else {
      const blob = await previewFileToBlob(base64);
      return saveImage(blob, filename);
    }
  } else {
    try {
      if (!base64) return Promise.resolve(false);
      const imageUrl = base64.startsWith('data:') || base64.startsWith('blob:')
        ? base64
        : `data:image/png;base64,${base64}`;
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = filename || 'image.png';
      link.style.display = 'none';
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
      }, 0);
      return Promise.resolve(true);
    } catch (e) {
      console.error('saveBase64Image failed:', e);
      return Promise.resolve(false);
    }
  }
};

export const saveImageInApp = async (blob: Blob, filename?: string) => {
  if (isInVest()) {
    const base64 = await blobToBase64(blob);
    return saveImageVest(base64);
  } else {
    return saveImage(blob, filename || '');
  }
};
